module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('el-select', {
    staticClass: "gv-geocoder",
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote": "",
      "size": "mini",
      "placeholder": "Ricerca Indirizzo...",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading,
      "loading-text": "Caricamento... ",
      "no-match-text": "Nessun indirizzo trovato",
      "no-data-text": "Nessun indirizzo trovato",
      "id": "gv-geocoder-pelias"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  }, _vm._l((_vm.results), function(item) {
    return _vm._c('el-option', {
      key: item.value,
      staticClass: "gv-geocoder-options",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40ca8980!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeocoderPelias.vue
// module id = 852
// module chunks = 39